export default __webpack_public_path__ + "static/media/whatsapp-logo.65655286.svg";